import React from 'react';

const StorefrontAndKioskContext = React.createContext();

export default StorefrontAndKioskContext;
